import axios from 'axios';
import _ from 'lodash';
import Config from '../../constants/config';
import { getLocalData } from '../global-storage';

const header = {
  'Content-Type': 'application/json',
  
};

let apiKit = axios.create({
  baseURL: Config.apiUrl,
  timeout: 60000, // <-- 60 seconds timeout
  headers: header
});


// ==============================
// RESPONSE INTERCEPTOR
// ==============================
apiKit.interceptors.response.use(
  function (response) {
    if (response.data.status === false) {
      const error = new Error(response.data.message);
      error.response = response;
      throw error;
    }
    return response;
  },
  function (error) {
    console.log("API ERROR !", error);

    // Timeout error handling
    if (error.code === 'ECONNABORTED') {
      console.log("⏱ Request timed out (Interceptor)");
      alert("Timeout", "⏱ Request timed out. Please refresh.");
    }

    return Promise.reject(error);
  }
);


// ==============================
// REQUEST INTERCEPTOR
// ==============================
apiKit.interceptors.request.use(
  function (request) {
    return request;
  },
  function (error) {
    console.log('API ERROR !', error.message);
    return Promise.reject(error);
  }
);


// ==============================
// URL PARAM HELPER
// ==============================
const updateQueryStringParameter = (uri, key, value) => {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
};


// ==============================
// MAIN AXIOS REQUEST FUNCTION
// ==============================
export const axiosRequest = async (
  method,
  url,
  filter,
  postBody,
  routeParams,
  skipFilterParam
) => {

  if (!_.isEmpty(routeParams)) {
    Object.keys(routeParams).forEach(key => {
      if (routeParams[key])
        url = updateQueryStringParameter(url, key, routeParams[key]);
    });
  }

  let body;
  let postBodyKeys =
    typeof postBody === 'object' ? Object.keys(postBody) : [];

  if (postBodyKeys.length === 1) {
    body = postBody[postBodyKeys.shift()];
  } else {
    body = postBody;
  }

  if (!_.isEmpty(filter)) {
    if (skipFilterParam) {
      filter = `?where=${encodeURI(JSON.stringify(filter))}`;
    } else {
      filter = `?filter=${encodeURI(JSON.stringify(filter))}`;
    }
  }

  console.log(url);

  const queryConfig = {
    headers: header,
    method: method,
    url: `/${url}${filter ? filter : ''}`,
  };

  if (!_.isEmpty(body)) {
    queryConfig['data'] = body ? JSON.stringify(body) : undefined;
  }

  let token = await getLocalData('accessToken');
  if (token) queryConfig.headers.Authorization = token;

  // ==============================
  // REQUEST + TIMEOUT CATCH
  // ==============================
  return apiKit
    .request(queryConfig)
    .then(res => res.data)
    .catch(err => {
      console.error(err);

      if (err.code === 'ECONNABORTED') {
        console.log("⏱ Timeout: Please refresh (axiosRequest)");
        alert("Timeout", "⏱ Request timed out. Please refresh.");
      }

      return null;
    });
};

export default apiKit;
